import { Paper, styled } from '@mui/material';

export const Container = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  padding: theme.spacing(4),
  borderRadius: `0`,
  width: '660px',
  height: '100%',
  boxSizing: 'border-box',
  position: 'relative',
  overflow: 'hidden'
}));
